'use client';

import * as React from 'react';

import { For, SegmentGroup } from '@chakra-ui/react';

type Item = {
	value:     string;
	label:     React.ReactNode;
	disabled?: boolean;
};

export type SegmentedControlProps = {
	items: Array<string | Item>;
} & SegmentGroup.RootProps;

function normalize(items: Array<string | Item>): Item[] {
	return items.map((item) => {
		if (typeof item === 'string') return {
			value: item,
			label: item,
		};

		return item;
	});
}

export const SegmentedControl = React.forwardRef<
	HTMLDivElement,
	SegmentedControlProps
>((props, ref) => {
	const { items, ...rest } = props;
	const data = React.useMemo(() => normalize(items), [ items ]);

	return (
		<SegmentGroup.Root ref={ref} display={'flex'} {...rest}>
			<SegmentGroup.Indicator />
			<For each={data}>
				{item => (
					<SegmentGroup.Item
						key={item.value}
						disabled={item.disabled}
						flex={1}
						placeContent={'center'}
						value={item.value}
					>
						<SegmentGroup.ItemText>{item.label}</SegmentGroup.ItemText>
						<SegmentGroup.ItemHiddenInput />
					</SegmentGroup.Item>
				)}
			</For>
		</SegmentGroup.Root>
	);
});

SegmentedControl.displayName = 'SegmentedControl';